import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/common/nyoni_white.png';
const _withScopeId = n => (_pushScopeId("data-v-6a8a27a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = {
  href: "/products/nyoni"
};
const _hoisted_4 = {
  href: "/products/feiyan"
};
const _hoisted_5 = {
  href: "tel:4008896590"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = {
  href: "tel:+8618157898718"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_9 = {
  href: "mailTo: nyoni@jlnyoni.com"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_11 = {
  href: "/about/jiuling"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_13 = {
  href: "javaScript:void(0)"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_15 = {
  class: "footer-bottom"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "copyright"
}, "©2022 NYONI DESIGNS", -1));
const _hoisted_17 = {
  class: "compinfo"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_createElementVNode("h1", null, _toDisplayString(_ctx.$t("common.footer.procudts.h1")), 1), _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t("common.footer.procudts.nyoni")), 1), _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t("common.footer.procudts.feiyan")), 1)]), _createElementVNode("div", null, [_createElementVNode("h1", null, _toDisplayString(_ctx.$t("common.footer.contact.h1")), 1), _createElementVNode("a", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.$t("common.footer.contact.landline")) + ": ", 1), _hoisted_6, _createTextVNode("400-8896-590")]), _createElementVNode("a", _hoisted_7, [_createTextVNode(_toDisplayString(_ctx.$t("common.footer.contact.phone")) + ": ", 1), _hoisted_8, _createTextVNode("+86 18157898718")]), _createElementVNode("a", _hoisted_9, [_createTextVNode(_toDisplayString(_ctx.$t("common.footer.contact.email")) + ": ", 1), _hoisted_10, _createTextVNode("nyoni@jlnyoni.com")])]), _createElementVNode("div", null, [_createElementVNode("h1", null, _toDisplayString(_ctx.$t("common.footer.about.h1")), 1), _createElementVNode("a", _hoisted_11, [_createTextVNode(_toDisplayString(_ctx.$t("common.footer.about.factory1")) + ": ", 1), _hoisted_12, _createTextVNode(_toDisplayString(_ctx.$t("common.footer.about.factory2")), 1)]), _createElementVNode("a", _hoisted_13, [_createTextVNode(_toDisplayString(_ctx.$t("common.footer.about.trade1")) + ": ", 1), _hoisted_14, _createTextVNode(_toDisplayString(_ctx.$t("common.footer.about.trade2")), 1)])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("common.footer.compinfo.compinfo")), 1)])]);
}